import React from 'react';

import { Page, LayoutSingleColumn } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import css from './LegalPages.module.css';

const LegalNoticePage = () => {
  return (
    <Page title="Mentions Légales | Neokasa" description="Mentions légales de la marketplace Neokasa." scrollingDisabled={false}>
      <LayoutSingleColumn topbar={<TopbarContainer />} footer={<FooterContainer />}>
        <div className={css.root}>
          <div className={css.container}>
            <div className={css.header}>
              <h1 className={css.title}>Mentions Légales</h1>
              <p className={css.subtitle}>Informations légales sur la marketplace Neokasa</p>
            </div>

            <div className={css.policyContent}>
              <section className={css.policySection}>
                <h2 className={css.sectionTitle}>1. Éditeur du site</h2>
                <p className={css.paragraph}>
                  Le site Neokasa est édité par :
                </p>
                <p className={css.paragraph}>
                  <strong>NEOKASA</strong><br />
                  SARL immatriculee au RCS de Draguignan sous le numero 895 231 140<br />
                  Raison sociale : Neokasa<br />
                  Forme juridique : SARL<br />
                  RCS : Draguignan 895 231 140<br />
                  Capital social : 100 EUR<br />
                  Siege social : 1701A route d'esparron 83560 Ginasservis<br />
                  Numero de TVA intracommunautaire : non communique<br />
                  Email : contact@neokasa.fr
                </p>
                <p className={css.paragraph}>
                  <strong>Directeur de la publication :</strong> Clement Petitimbert
                </p>
                <p className={css.paragraph}>
                  Pour plus d'informations sur le responsable du traitement des données personnelles, consultez notre <a href="/privacy-policy" className={css.legalLink}>Politique de confidentialité</a>.
                </p>
              </section>

              <section className={css.policySection}>
                <h2 className={css.sectionTitle}>2. Hébergement</h2>
                <p className={css.paragraph}>
                  Le site est heberge par <strong>Heroku, Inc.</strong>
                </p>
                <p className={css.paragraph}>
                  1 Market St Ste 300<br />
                  San Francisco, California 94105<br />
                  Etats-Unis
                </p>
                <p className={css.paragraph}>
                  Pour plus d'informations sur le stockage et le transfert des données, consultez notre <a href="/privacy-policy" className={css.legalLink}>Politique de confidentialité</a>.
                </p>
              </section>

              <section className={css.policySection}>
                <h2 className={css.sectionTitle}>3. Propriété intellectuelle</h2>
                <p className={css.paragraph}>
                  L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur et la propriété intellectuelle. Tous les droits de reproduction sont réservés, y compris pour les documents téléchargeables et les représentations iconographiques et photographiques.
                </p>
                <p className={css.paragraph}>
                  La reproduction de tout ou partie de ce site sur un support électronique quel qu'il soit est formellement interdite sauf autorisation expresse du responsable de la publication.
                </p>
              </section>

              <section className={css.policySection}>
                <h2 className={css.sectionTitle}>4. Conditions d'utilisation</h2>
                <p className={css.paragraph}>
                  L'utilisation de la marketplace Neokasa est régie par nos <a href="/terms-of-service" className={css.legalLink}>Conditions Générales d'Utilisation</a>, qui définissent les règles applicables à l'utilisation de la plateforme, les droits et obligations des utilisateurs, ainsi que le fonctionnement de la marketplace.
                </p>
              </section>

              <section className={css.policySection}>
                <h2 className={css.sectionTitle}>5. Protection des données personnelles et cookies</h2>
                <p className={css.paragraph}>
                  La collecte, l'utilisation et la protection de vos données personnelles sont détaillées dans notre <a href="/privacy-policy" className={css.legalLink}>Politique de confidentialité</a>, conforme au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés.
                </p>
                <p className={css.paragraph}>
                  Pour toute question concernant vos données personnelles ou pour exercer vos droits (accès, rectification, effacement, portabilité, etc.), vous pouvez nous contacter à <a href="mailto:contact@neokasa.fr" className={css.legalLink}>contact@neokasa.fr</a>.
                </p>
              </section>
            </div>

            <div className={css.contactSection}>
              <h2 className={css.contactTitle}>Besoin d'aide concernant les Mentions Légales ?</h2>
              <p className={css.contactText}>
                Pour toute question concernant les mentions légales ou les informations légales de la marketplace, notre équipe d'assistance est à votre disposition.
              </p>
              <div className={css.contactButtons}>
                <a href="/contact" className={css.contactButton}>
                  Contacter le support
                </a>
                <a href="mailto:contact@neokasa.fr" className={css.contactButtonSecondary}>
                  Assistance par e-mail
                </a>
              </div>
            </div>
          </div>
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

export default LegalNoticePage;

